var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkippedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_177_12649",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_177_12649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.16675 10.8333H13.8334C14.0695 10.8333 14.2674 10.7535 14.4272 10.5937C14.5869 10.434 14.6667 10.2361 14.6667 9.99999C14.6667 9.76388 14.5869 9.56596 14.4272 9.40624C14.2674 9.24652 14.0695 9.16666 13.8334 9.16666H7.16675C6.93064 9.16666 6.73272 9.24652 6.573 9.40624C6.41328 9.56596 6.33341 9.76388 6.33341 9.99999C6.33341 10.2361 6.41328 10.434 6.573 10.5937C6.73272 10.7535 6.93064 10.8333 7.16675 10.8333ZM10.5001 18.3333C9.3473 18.3333 8.26397 18.1146 7.25008 17.6771C6.23619 17.2396 5.35425 16.6458 4.60425 15.8958C3.85425 15.1458 3.2605 14.2639 2.823 13.25C2.3855 12.2361 2.16675 11.1528 2.16675 9.99999C2.16675 8.84721 2.3855 7.76388 2.823 6.74999C3.2605 5.7361 3.85425 4.85416 4.60425 4.10416C5.35425 3.35416 6.23619 2.76041 7.25008 2.32291C8.26397 1.88541 9.3473 1.66666 10.5001 1.66666C11.6529 1.66666 12.7362 1.88541 13.7501 2.32291C14.764 2.76041 15.6459 3.35416 16.3959 4.10416C17.1459 4.85416 17.7397 5.7361 18.1772 6.74999C18.6147 7.76388 18.8334 8.84721 18.8334 9.99999C18.8334 11.1528 18.6147 12.2361 18.1772 13.25C17.7397 14.2639 17.1459 15.1458 16.3959 15.8958C15.6459 16.6458 14.764 17.2396 13.7501 17.6771C12.7362 18.1146 11.6529 18.3333 10.5001 18.3333Z",
    fill: "#464646"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkippedIcon);
export default __webpack_public_path__ + "static/media/skipped_icon.49877c0dbdabf4d797f88e87fa849a01.svg";
export { ForwardRef as ReactComponent };